import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isToolsExpanded, setIsToolsExpanded] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToAbout = (e) => {
    e.preventDefault();
    const aboutSection = document.getElementById('about-content');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
      closeMobileMenu();
    } else if (location.pathname !== '/') {
      window.location.href = '/#about-content';
    }
  };

  return (
    <div className="layout">
      <header className="App-header">
        <div className="nav-content">
          <Link to="/" className="logo-link">Sam Penny</Link>
          
          <nav className="desktop-nav">
            <a 
              href="/#about-content" 
              onClick={scrollToAbout}
              className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
            >
              About
            </a>
            <Link 
              to="/blog" 
              className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}
            >
              Blog
            </Link>
            <div className="nav-dropdown">
              <a 
                href="#" 
                onClick={(e) => e.preventDefault()}
                className={`nav-link has-dropdown ${location.pathname.startsWith('/tools') ? 'active' : ''}`}
              >
                Tools
              </a>
              <div className="dropdown-content">
                <Link to="/tools/inp" className="dropdown-item">INP Visualiser</Link>
                <Link to="/blog/watchwithout" className="dropdown-item">WatchWithout</Link>
              </div>
            </div>
            <Link 
              to="/contact" 
              className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            >
              Contact
            </Link>
          </nav>

          <button className="hamburger-menu" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      <div 
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={closeMobileMenu}
      ></div>

      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <button 
          className="mobile-menu-close"
          onClick={closeMobileMenu}
          aria-label="Close menu"
        />
        <div className="mobile-menu-content">
          <a 
            href="/#about-content" 
            className="mobile-nav-link"
            onClick={scrollToAbout}
          >
            About
          </a>
          <Link 
            to="/blog" 
            className="mobile-nav-link"
            onClick={closeMobileMenu}
          >
            Blog
          </Link>
          <div className="mobile-nav-group">
            <button 
              className="mobile-nav-link"
              onClick={(e) => {
                e.preventDefault();
                setIsToolsExpanded(!isToolsExpanded);
              }}
            >
              Tools
              <span>{isToolsExpanded ? '▼' : '▶'}</span>
            </button>
            {isToolsExpanded && (
              <>
                <Link 
                  to="/tools/inp" 
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  INP Visualiser
                </Link>
                <Link 
                  to="/blog/watchwithout" 
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  WatchWithout
                </Link>
              </>
            )}
          </div>
          <Link 
            to="/contact" 
            className="mobile-nav-link"
            onClick={closeMobileMenu}
          >
            Contact
          </Link>
        </div>
      </div>

      <main className="main-content">
        {children}
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Get in touch</h4>
            <p>Reach out to discuss speaking, guest posting or shorter consultation opportunities.</p>
            <Link to="/contact" className="cta-button">Contact Me</Link>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <p>Sam Penny<br />Northcote, Australia</p>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/pennysam/" target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/images/linkedin-dark.svg" alt="LinkedIn" loading="lazy" />
              </a>
              <a href="https://x.com/sampennyseo" target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/images/x-dark.svg" alt="X (formerly Twitter)" loading="lazy" />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <p>© Sam Penny {new Date().getFullYear()}</p>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 